
import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer,
  BarChart, Bar
} from 'recharts';
import { ChartEntry } from '../../types/chart';

interface ChartCardProps {
  title: string;
  data: ChartEntry[];
  icon?: React.ReactNode;
  type?: 'line' | 'bar';
  loading?: boolean;
}

export default function ChartCard({ 
  title, 
  data, 
  icon, 
  type = 'line',
  loading = false 
}: ChartCardProps) {
  if (loading) {
    return (
      <div className="chart-card">
        <div className="chart-header">
          <h3 className="chart-title">
            {icon}
            {title}
          </h3>
        </div>
        <div className="chart-container">
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <div className="spinner"></div>
          </div>
        </div>
      </div>
    );
  }
  
  if (data.length === 0) {
    return (
      <div className="chart-card">
        <div className="chart-header">
          <h3 className="chart-title">
            {icon}
            {title}
          </h3>
        </div>
        <div className="chart-container">
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%', color: 'var(--text-muted)' }}>
            No data available for the selected time range
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="chart-card">
      <div className="chart-header">
        <h3 className="chart-title">
          {icon}
          {title}
        </h3>
      </div>
      <div className="chart-container">
        {type === 'line' ? (
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" />
              <XAxis dataKey="label" stroke="var(--text-muted)" />
              <YAxis stroke="var(--text-muted)" />
              <Tooltip 
                contentStyle={{ 
                  background: 'var(--card-bg)', 
                  border: '1px solid var(--border-light)',
                  borderRadius: '8px' 
                }} 
              />
              <Line 
                type="monotone" 
                dataKey="value" 
                stroke="var(--primary)" 
                strokeWidth={2}
                dot={{ stroke: 'var(--primary)', strokeWidth: 2, r: 4, fill: 'var(--card-bg)' }}
                activeDot={{ stroke: 'var(--primary)', strokeWidth: 2, r: 6, fill: 'var(--primary)' }}
              />
            </LineChart>
          </ResponsiveContainer>
        ) : (
          <ResponsiveContainer width="100%" height="100%">
            <BarChart data={data} layout="vertical">
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255, 255, 255, 0.1)" horizontal={false} />
              <XAxis type="number" stroke="var(--text-muted)" />
              <YAxis dataKey="label" type="category" width={120} stroke="var(--text-muted)" />
              <Tooltip 
                contentStyle={{ 
                  background: 'var(--card-bg)', 
                  border: '1px solid var(--border-light)',
                  borderRadius: '8px' 
                }} 
              />
              <Bar dataKey="value" fill="var(--primary)" radius={[0, 4, 4, 0]} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}